import { render, staticRenderFns } from "./newApply.vue?vue&type=template&id=1585ef9c&"
import script from "./newApply.vue?vue&type=script&lang=js&"
export * from "./newApply.vue?vue&type=script&lang=js&"
import style0 from "./newApply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports